import type { QuizScenariosTranslations } from './quizScenarios.translation.pl.ts';

export const quizScenariosTranslations: QuizScenariosTranslations = {
  intro: {
    segment1: {
      title: "Ugh… The same thing again. The reset didn't help. What's up with this cyber-compass?",
      content: {
        1: "Oh, hi! I'm glad to see you! I'm Orin. I've just joined Orange, and the first task I got is to calibrate my values compass, only it… for some reason sent me back in time and I ended up here. But... maybe that's because you're the one who's supposed to help me with it?",
        2: "Oh, wait a minute… I can see you want to join the Let’s Orange internships! Great! We can help each other. I'll calibrate three values: courage, mindfulness and responsibility, and along the way you'll find out whether your values are close to the ones that matter at Orange.",
        3: "So? Shall we begin? Come on, play it your way! A portal is opening - we're off on a journey through time!",
      },
    },
    segment2: {
      title:
        "Welcome to the future! Yes, you're seeing right. We're on the Moon, which is now an important place on Orange's space map.",
      content:
        "This is where people work on making the 14G connection for numerous expeditions perfect. Our satellite is great for that. Working conditions here aren't easy, which is why robots working alongside humans do the hardest tasks. Quite something, huh?",
    },
  },
  errors: {
    videoNotSupported: 'Your browser does not support the video element.',
    errorBrowser: 'Network error or connection problem.',
  },
  buttons: {
    next: 'Next',
  },
};
